/**
 * Popular search chips in the search drawer: a tap fills the field and runs the predictive search in place.
 * Without this module the chips are plain links to the search page.
 */
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) return;

  const chip = event.target.closest('[data-search-term]');
  if (!(chip instanceof HTMLElement)) return;
  const component = chip.closest('predictive-search-component');
  const input = component?.querySelector('input[type="search"]');
  if (!(input instanceof HTMLInputElement)) return;

  const term = chip.dataset.searchTerm || '';
  if (!term) return;

  event.preventDefault();
  input.value = term;
  input.focus({ preventScroll: true });
  input.setSelectionRange(term.length, term.length);
  input.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: term }));
});
